import { render, staticRenderFns } from "./CreateResolutionsCatalog.vue?vue&type=template&id=1eae1e38&"
import script from "./CreateResolutionsCatalog.vue?vue&type=script&lang=js&"
export * from "./CreateResolutionsCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports